import { create } from 'zustand';

interface TourState {
  open: boolean;
  start: () => void;
  close: () => void;
}

export const useTourStore = create<TourState>((set) => ({
  open: false,
  start: () => set({ open: true }),
  close: () => set({ open: false }),
}));
